export const KEY_ENTER = 13;

export const KEY_SPACE = 32;

export const KEY_TAB = 9;
